import styled from 'styled-components';

export default styled.div`
  overscroll-behavior: contain;
`;
